import { RolodexEntryType, RolodexLoadedEntryJson } from 'types'

import type { DocumentOcrJSON } from './ocrViewer'

export const DOCUMENT_ID_FIELD = 'document_id'
export const PAGE_ID_FIELD = 'page_id'
export const PIPELINE_CONFIG_HASH_FIELD = 'pipeline_config_hash'
export const CANTILEVER_DOCUMENT_TAG = 'cantilever-document'
export const CANTILEVER_DOCUMENT_PAGE_TAG = 'cantilever-document-page'

export interface SystemDocumentJSON {
  id: string
  /** Stable BigQuery document id when present (Phase 0+ / migrated sites). */
  document_id?: string
  /** Original source document id used by services that index canonical docs. */
  source_document_id?: string
  /** Shortened pipeline-config hash when present. */
  pipeline_config_hash?: string
  size: number
  type: string
  uploadDate: string
  title: string
  filename: string
  description: string
  vendor_name?: string
  document_type?: string
  document_title?: string
  drawing_number?: string
  system?: string
  revision_code?: string
  revision_date?: string
  total_pages?: number
  rich_text_summary?: string
}

export interface SystemDocumentPageJSON {
  id: string
  document_id?: string
  page_id?: string
  pipeline_config_hash?: string
  page_num: number
}

export type DocumentOcrEntry = {
  entry: {
    id: string
    type: RolodexEntryType.DOCUMENT_OCR
    data: DocumentOcrJSON
    tags: {
      site: string
      'system-document': string
    }
  }
}

export type SystemDocumentEntry = RolodexLoadedEntryJson & {
  entry: {
    id: string
    type: RolodexEntryType.SYSTEM_DOCUMENT
    data: SystemDocumentJSON
    tags: {
      [key: string]: string
    }
    updated_at: string
    last_updated_by: string
  }
}

export type SystemDocumentPageEntry = RolodexLoadedEntryJson & {
  entry: {
    id: string
    type: RolodexEntryType.SYSTEM_DOCUMENT_PAGE
    data: SystemDocumentPageJSON
    tags: {
      [key: string]: string
    }
  }
}

export function getSystemDocumentBqId(
  entry: SystemDocumentEntry
): string | undefined {
  const fromField = entry.entry.data.document_id
  if (typeof fromField === 'string' && fromField.length > 0) {
    return fromField
  }
  return undefined
}

export function getIntraDocSearchDocumentId(
  entry: SystemDocumentEntry
): string {
  const sourceDocumentId = entry.entry.data.source_document_id
  return typeof sourceDocumentId === 'string' && sourceDocumentId.length > 0
    ? sourceDocumentId
    : entry.entry.id
}

export function getCantileverDocumentId(
  entry: SystemDocumentEntry
): string | undefined {
  const tag = entry.entry.tags[CANTILEVER_DOCUMENT_TAG]
  if (typeof tag === 'string' && tag.length > 0) {
    return tag
  }
  return undefined
}

export function getCantileverDocumentPageId(
  entry: SystemDocumentPageEntry
): string | undefined {
  const tag = entry.entry.tags[CANTILEVER_DOCUMENT_PAGE_TAG]
  if (typeof tag === 'string' && tag.length > 0) {
    return tag
  }
  return undefined
}
